import React, { useContext, useState } from 'react';
import { Modal, Button, Row, Col, Card } from 'react-bootstrap';
import { Store } from '../Store';
import api, { API_BASE_URL } from '../api';
import { Link } from 'react-router-dom';

function Product(props) {
  const { product } = props;

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    cart: { cartItems },
  } = state;

  const [showModal, setShowModal] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const openModalHandler = () => {
    setShowModal(true);
  };

  const closeModalHandler = () => {
    setShowModal(false);
    setSelectedSize(null);
    setSelectedColor(null);
    setQuantity(1);
  };

  const addToCartHandler = async () => {
    const hasSizes = product.sizes && product.sizes.length > 0;
    if (hasSizes && !selectedSize) {
      alert('Please select a size');
      return;
    }

    const hasColors = hasSizes && product.sizes.some(s => s.colors.some(c => c.color && c.color !== ''));
    const currentSizeColors = (hasSizes && selectedSize) ? product.sizes.find(s => s.size === selectedSize)?.colors.filter(c => c.color && c.color !== '') : [];
    
    if (hasColors && currentSizeColors && currentSizeColors.length > 0 && !selectedColor) {
      alert('Please select a color');
      return;
    }

    const existItem = cartItems.find(
      (x) => x._id === product._id && x.selectedSize === selectedSize && x.selectedColor === selectedColor
    );
    const quantityToAdd = existItem ? existItem.quantity + quantity : quantity;

    const { data } = await api.get(`/api/products/${product._id}`);


    ctxDispatch({
      type: 'CART_ADD_ITEM',
      payload: { ...product, quantity: quantityToAdd, selectedSize, selectedColor },
    });

    closeModalHandler();
  };

  return (
    <>
      <Card className="rounded-5 overflow-hidden shadow-sm">
        <Link to={`/product/${product.slug}`}>
          <img
            src={product.image ? (product.image.startsWith('http') ? product.image : `${API_BASE_URL}/storage/${product.image}`) : ''}
            className="card-img-top rounded-t-lg transition-transform duration-300 ease-in-out hover:scale-105"
            alt={product.name}
            style={{
              width: '100%',
              height: '400px',
              objectFit: 'cover',
            }}
          />
        </Link>

        <Card.Body>
          <Link to={`/product/${product.slug}`}>
            <Card.Title>{product.name}</Card.Title>
          </Link>
          <Card.Text>ID :- {product.code}</Card.Text>
          <Button 
            onClick={openModalHandler}
            style={{
              backgroundColor: '#801001',
              color: 'white',
              border: 'none',
              fontWeight: 'bold',
              width: '100%',
              padding: '0.6rem'
            }}
          >
            Add to cart
          </Button>
        </Card.Body>
      </Card>

      {/* Modal for selecting size and quantity */}
      <Modal show={showModal} onHide={closeModalHandler} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Size and Quantity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {product.sizes && product.sizes.length > 0 && (
            <Row>
              <Col xs={3}>Size:</Col>
              <Col xs={9} className="d-flex flex-wrap gap-2">
                {product.sizes.map((sizeObj) => (
                  <div
                    key={sizeObj.size}
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      padding: '8px 12px',
                      cursor: 'pointer',
                      backgroundColor:
                        selectedSize === sizeObj.size ? '#801001' : '#f8f9fa',
                      color: selectedSize === sizeObj.size ? 'white' : 'black',
                    }}
                    onClick={() => setSelectedSize(sizeObj.size)}
                  >
                    {sizeObj.size}
                  </div>
                ))}
              </Col>
            </Row>
          )}

          {selectedSize && product.sizes.find(s => s.size === selectedSize)?.colors.some(c => c.color && c.color !== '') && (
            <Row className="mt-3">
              <Col xs={3}>Color:</Col>
              <Col xs={9} className="d-flex flex-wrap gap-2">
                {product.sizes
                  .find((s) => s.size === selectedSize)
                  ?.colors.filter(c => c.color && c.color !== '')
                  .map((cObj) => (
                    <div
                      key={cObj.color}
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '20px',
                        padding: '4px 12px',
                        cursor: 'pointer',
                        fontSize: '0.9rem',
                        backgroundColor:
                          selectedColor === cObj.color ? '#801001' : '#f8f9fa',
                        color: selectedColor === cObj.color ? 'white' : 'black',
                      }}
                      onClick={() => setSelectedColor(cObj.color)}
                    >
                      {cObj.color}
                    </div>
                  ))}
              </Col>
            </Row>
          )}

          <Row className="mt-3 align-items-center">
            <Col xs={3}>Quantity:</Col>
            <Col xs={9}>
              <div className="d-flex align-items-center gap-2">
                {/* Decrease by 5 */}
                <Button
                  variant="light"
                  onClick={() => setQuantity((q) => Math.max(1, q - 5))}
                  disabled={quantity <= 1}
                  style={{ color: '#801001' }}
                  title="Decrease by 5"
                >
                  <i className="fas fa-minus-circle"></i>
                </Button>

                {/* Decrease by 1 */}
                <Button
                  variant="light"
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  disabled={quantity === 1}
                  style={{ color: '#801001' }}
                  title="Decrease by 1"
                >
                  <i className="fas fa-minus"></i>
                </Button>

                {/* Quantity display */}
                <span style={{ minWidth: '30px', textAlign: 'center' }}>
                  {quantity}
                </span>

                {/* Increase by 1 */}
                <Button
                  variant="light"
                  onClick={() =>
                    setQuantity((q) => q + 1)
                  }
                  style={{ color: '#801001' }}
                  title="Increase by 1"
                >
                  <i className="fas fa-plus"></i>
                </Button>

                {/* Increase by 5 */}
                <Button
                  variant="light"
                  onClick={() =>
                    setQuantity((q) => q + 5)
                  }
                  style={{ color: '#801001' }}
                  title="Increase by 5"
                >
                  <i className="fas fa-plus-circle"></i>
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={closeModalHandler}>
            Cancel
          </Button>
          {(() => {
            const hasSizes = product.sizes && product.sizes.length > 0;
            const needsSize = hasSizes && !selectedSize;
            const currentSizeColors = (hasSizes && selectedSize) 
              ? product.sizes.find(s => s.size === selectedSize)?.colors.filter(c => c.color && c.color !== '') 
              : [];
            const needsColor = selectedSize && currentSizeColors && currentSizeColors.length > 0 && !selectedColor;
            const isDisabled = needsSize || needsColor;
            
            let buttonText = 'Add to Cart';
            if (needsSize) buttonText = 'Select a Size';
            else if (needsColor) buttonText = 'Select a Color';
            
            return (
              <Button
                className="flex-grow-1"
                disabled={isDisabled}
                style={{
                  backgroundColor: isDisabled ? '#a0a0a0' : '#801001',
                  border: 'none',
                  color: 'white',
                  fontWeight: 'bold',
                  cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}
                onClick={addToCartHandler}
              >
                {buttonText}
              </Button>
            );
          })()}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Product;
